<template>
  <div>
    <div v-if="submittedBloodTest" class="success-bar floating">{{t("Blood test submitted successfully")}}</div>

    <PlanEnded v-if="planEnded" />
    <div v-else class="boxes light purple">
      <Box :title="t('Shopping List')" :thumb="shoppingListIcon" link="/plan/tools/shopping-list" bg="#D1E9E1"></Box>
      <Box :title="t('Recommended Products')" :thumb="recommendedIcon" link="/plan/products" bg="#fcecc3">{{t("Information items to help you along the course")}}</Box>
      <Box :title="t('Info Slides')" :thumb="infoSlidesIcon" link="/plan/tools/info-slides" bg="#FCC8C3">{{t("Information items to help you along the course")}}</Box>
      <Box :title="t('Blood Test Section')" :thumb="bloodTestIcon" link="/plan/tools/blood-test" bg="#ccefff">{{t("blood-test-comment")}}</Box>
      <Box :title="t('Fasting Calculator')" :thumb="fastingCalculatorIcon" link="/plan/tools/fasting-calculator" bg="#C3E7FC" v-if="daysInPlan >= 22">{{t("Manage your fasting and watch your fasting history")}}</Box>
    </div>
  </div>
</template>

<script>

import t from '@/lib/Locale';
import Box from "@/components/ui/widgets/Box";
import ArrowRightIcon from '@/assets/icons/arrow-right.svg';
import ExclusivesIcon from '@/assets/icons/menu/exclusives.svg';
import PeriodIcon from '@/assets/icons/menu/woman.svg';
import RecipesIcon from '@/assets/icons/menu/recipes.svg';
import FastingIcon from '@/assets/icons/menu/yoga.svg';
import ChartIcon from '@/assets/icons/menu/presentation-chart.svg';
import recommendedIcon from '@/assets/icons/recommended-icon.png';

import bloodTestIcon from '@/assets/icons/tools-blood-test.png';
import shoppingListIcon from '@/assets/icons/tools-shopping-list.png';
import infoSlidesIcon from '@/assets/icons/tools-info-slides.png';
import periodCalculatorIcon from '@/assets/icons/tools-period.png';
import fastingCalculatorIcon from '@/assets/icons/tools-fasting.png';


import Fito from "@/lib/fito";
import ShoppingList from "@/components/views/plan/tools/ShoppingList.vue";
import PlanEnded from "@/components/ui/plan/PlanEnded.vue";
import {isInPlan, Plan_followup, Plan_trainers} from "@/lib/PlanUtils";

const TotalPlanDays = 100;

export default {
  name: "ToolsHome",
  computed: {
    ShoppingList() {
      return ShoppingList
    }
  },
  props: ["meta"],
  components: {PlanEnded, Box},
  data() {
    return {
      ArrowRightIcon, ExclusivesIcon, RecipesIcon, PeriodIcon, FastingIcon, ChartIcon, bloodTestIcon,
      shoppingListIcon, infoSlidesIcon, periodCalculatorIcon, fastingCalculatorIcon, recommendedIcon,
      lists: [],
      daysInPlan: 0,
      submittedBloodTest: false,
      showBloodTest: false,

      planEnded: false,
    }
  },

  async mounted() {
    const login = await Fito().Login.safeCheckLogin()
    if (!login) return this.$router.push('/plan/login')

    this.planEnded = login.daysInPlan > TotalPlanDays && !isInPlan(login, [Plan_followup, Plan_trainers])

    this.daysInPlan = login.daysInPlan

    if (window.location.search.includes('submitted_blood_test')) {
      this.submittedBloodTest = true
    }

    if (login.subscriber && login.subscriber.email === "shay@fito.ai") {
      this.showBloodTest = true
    }

  },

  methods : {
    t,
  },

  watch : {
  }

}
</script>
